import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["region", "page", "scrollContainer"];

  connect() {
    this.focusHandler = (event) => this.highlight(event.detail, false);
    this.jumpHandler = (event) => this.highlight(event.detail, true);
    this.clearHandler = () => this.clear();

    window.addEventListener("ocr-source:focus", this.focusHandler);
    window.addEventListener("ocr-source:jump", this.jumpHandler);
    window.addEventListener("ocr-source:clear", this.clearHandler);
  }

  disconnect() {
    window.removeEventListener("ocr-source:focus", this.focusHandler);
    window.removeEventListener("ocr-source:jump", this.jumpHandler);
    window.removeEventListener("ocr-source:clear", this.clearHandler);
  }

  highlight(source, shouldScroll) {
    this.clear();
    if (!source) return;

    const regions = this.matchingRegions(source);
    regions.forEach((region) => {
      region.classList.add(
        "border-primary",
        "bg-primary/20",
        "ring-2",
        "ring-primary",
        "z-20",
        "shadow-lg"
      );
    });

    const target = regions[0] || this.pageTargets.find((page) => {
      return Number(page.dataset.pageNumber) === Number(source.page);
    });

    if (shouldScroll && target) {
      target.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  clear() {
    this.regionTargets.forEach((region) => {
      region.classList.remove(
        "border-primary",
        "bg-primary/20",
        "ring-2",
        "ring-primary",
        "z-20",
        "shadow-lg"
      );
    });
  }

  showPdfFallback(event) {
    const image = event.currentTarget;
    const fallbackUrl = image.dataset.pdfFallbackUrl;
    if (!fallbackUrl || image.dataset.pdfFallbackShown === "true") return;

    image.dataset.pdfFallbackShown = "true";

    const iframe = document.createElement("iframe");
    iframe.src = fallbackUrl;
    iframe.title = `${image.alt || "Page"} - PDF original`;
    iframe.loading = "lazy";
    iframe.className = "absolute inset-0 z-0 h-full w-full border-0 bg-white";

    image.replaceWith(iframe);
  }

  matchingRegions(source) {
    if (source.line_item_id) {
      const lineItemRegions = this.regionTargets.filter((region) => {
        return Number(region.dataset.sourceLineItemId) === Number(source.line_item_id);
      });

      if (lineItemRegions.length > 0) return lineItemRegions;
    }

    const blockIds = Array.isArray(source.block_ids) ? source.block_ids : [];
    if (blockIds.length > 0) {
      return this.regionTargets.filter((region) => {
        return blockIds.includes(region.dataset.blockId);
      });
    }

    return this.regionTargets.filter((region) => {
      return Number(region.dataset.pageNumber) === Number(source.page);
    });
  }
}
